import authRoles from 'app/auth/authRoles';
import UserManagement from './UserManagement';

const UserManagementConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/usermanagement',
			component: UserManagement,
		},
	],
	auth: authRoles.admin,
};

export default UserManagementConfig;
